export default {
  "bank.ux.revokePayeeWarning": "Revoke recipient acknowledgement",
  "bank.ux.warningAccepted": "Warning accepted by OWNER Finance; the bank has not confirmed the recipient.",
  "bank.ux.acceptPayeeWarning": "I understand that the bank has not confirmed the recipient and authorise creating a draft with these details.",
  "bank.ux.checkNotPossible": "The bank could not verify the recipient.",
  "bank.ux.checkPending": "The bank has not returned a result in time. This does not mean the IBAN is incorrect.",
  "bank.ux.creatingDrafts": "Creating bank drafts…",
  "bank.ux.checkInvalidIban": "The IBAN is missing or invalid. Enter the correct recipient IBAN.",
  "bank.ux.checkPermission": "Your role or bank authority does not permit this action. Ask the organization administrator to check your access.",

  "bank.ux.checkIssues": "Recipient checks need a decision",
  "bank.ux.checkIssuesHelp": "No bank drafts have been created. Review the warnings below. OWNER Finance can acknowledge an unsuccessful check and continue.",
  "bank.ux.checkMismatch": "The bank could not match the account and recipient. Check the IBAN.",
  "bank.ux.checkName": "Confirm the recipient name suggested by the bank.",
  "bank.ux.checkUnavailable": "The recipient could not be verified. Retry or check the details.",
  "bank.ux.acceptBankName": "Confirm the recipient name reported by the bank: {name}",
  "bank.ux.correctRecipientIban": "Correct recipient IBAN (leave blank to keep it)",
  "bank.ux.checkingRecipients": "Checking recipients…",
  "bank.ux.recheckAndContinue": "Check again and continue",
  "bank.ux.checkAndContinue": "Check recipients and continue",

  "payables.dueBefore": "Due by",
  "payables.currency": "Currency",
  "payables.allCurrencies": "All currencies",
  "payables.selectFiltered": "Select matching invoices",
  "payables.clearSelection": "Clear selection",
  "payables.selectSupplier": "Select supplier",
  "payables.selectionLimit": "Select up to 100 invoices. Narrow the filter.",
  "payables.chooseCurrency": "Choose one currency.",

  "bank.ux.timeBudgetPaused": '{created} drafts created; {remaining} not yet created. Paused early to allow time for bank responses. Completed drafts are saved.',
  "bank.ux.timeBudgetNotCreated": 'This draft has not been created in the bank.',
  "bank.ux.continueRemaining": 'Continue remaining drafts',
  "bank.ux.enableDescription": "Connect BluOr to prepare payment drafts for suppliers. Payments are approved in your bank.",
  "bank.ux.bankSandbox": "This connection will use the BluOr bank sandbox.",
  "bank.ux.enableBank": "Set up BluOr",
  "bank.ux.platformSetupRequired": "A platform administrator must enable the bank integration first.",
  'bank.ux.setupUnavailable': 'Bank connections have not been enabled for this organization. An administrator must enable bank setup.',
  "bank.ux.ownerOrganization": "Owning organization",
  "bank.ux.ownerMissing": "No organization linked",
  "bank.ux.savedRefreshError": "The change was saved, but the account list could not be refreshed. Reload the page to see the current status.",
  "bank.ux.title": "Payables",
  "bank.ux.subtitle": "Prepare payment lists and manage your banks. Payments are signed in your bank.",
  "bank.ux.business": "Business",
  "bank.ux.organization": "Paying organization",
  "bank.ux.selectedOrganization": "Selected organization",
  "bank.ux.banks": "My banks",
  "bank.ux.prepare": "Prepare a payment list",
  "bank.ux.saved": "Saved lists",
  "bank.ux.more": "More tools",
  "bank.ux.settings": "Bank settings",
  "bank.ux.accounts": "Organization accounts",
  "bank.ux.supplierAccounts": "Confirm supplier accounts",
  "bank.ux.access": "Who can prepare payments",
  "bank.ux.history": "Activity history",
  "bank.ux.support": "Details for support",
  "bank.ux.connect": "Connect a bank",
  "bank.ux.empty": "Connect your bank to check access to your organization’s accounts.",
  "bank.ux.reading": "Account access confirmed",
  "bank.ux.readOnly": "Account access is available. Creating payment drafts in this bank is not available yet.",
  "bank.ux.draftSupport": "This connection supports bank payment drafts. Available actions also depend on your permissions.",
  "bank.ux.test": "Test connection",
  "bank.ux.pending": "Continue setup",
  "bank.ux.state.DRAFT": "Setup incomplete",
  "bank.ux.state.VALIDATING": "Checking access",
  "bank.ux.state.ACTIVE": "Access checked",
  "bank.ux.state.SUSPENDED": "Paused",
  "bank.ux.state.ERROR": "Needs attention",
  "bank.ux.state.DRAINING": "Closing after ongoing operations",
  "bank.ux.state.RETIRED": "Disconnected",
  "bank.ux.checked": "Last checked: {date}",
  "bank.ux.notChecked": "Access has not been checked",
  "bank.ux.setupTitle": "Connect your bank",
  "bank.ux.step": "Step {current} of {total}",
  "bank.ux.credentialsHelp": "Enter the access details issued by your bank. These fields are sent securely and cleared after saving.",
  "bank.ux.where": "Where do I find these details?",
  "bank.ux.whereHint": "Use the access details supplied by BluOr when registering your public key. If Client ID or Client Secret is missing, request it from your bank.",
  "bank.ux.registration": "In BluOr Internet Bank, open Settings → Key Management → Add Files. Upload the downloaded public key, select it and press Send. Then return here.",
  "bank.ux.computer": "You can continue on a computer: sign in to the same organization and open My banks. Setup progress is saved; passwords are not transferred.",
  "bank.ux.rotate": "Update access details",
  "bank.ux.disconnect": "Disconnect bank",
  "bank.ux.accountHelp": "If no account is found, add or activate your organization’s IBAN in Bank settings → Organization accounts, then check access again.",
  "bank.ux.self": "Me",
  "bank.ux.advanced": "Other recipients of access",
  "bank.ux.authorityHint": "Granting access is a separate action. Connecting a bank does not grant payment preparation rights.",
  "merchant.ap.debtorAccountIdentifier": "Organization IBAN",
  "merchant.ap.subjectType": "Grant access to",
  "merchant.ap.createAuthority": "Grant preparation access",
  "merchant.ap.connectionScope": "Bank for this access",
  "merchant.ap.anyConnection": "All available connections",
  "bank.wizard.payer": "Paying organization",
  "bank.wizard.generateKey": "Create connection key",
  "bank.wizard.keyHint": "Create a connection key. Only its public part is downloaded and registered with the bank.",
  "bank.wizard.brokerUnavailable": "Connection setup is temporarily unavailable. Your progress is saved; contact the platform administrator.",
  "bank.wizard.step.COMPLETE": "Confirm connection",
  "bank.wizard.step.PUBLIC_KEY": "Download the key for your bank",
  "bank.wizard.step.KEY": "Create your connection key",
  "bank.wizard.step.REGISTRATION": "Register the key with your bank",
  "bank.ux.account.SUPERSEDED": "Replaced by a newer account revision",
  "bank.ux.account.CANDIDATE": "Waiting for activation",
  "bank.ux.account.ACTIVE": "Account available",
  "bank.ux.account.ARCHIVED": "Archived",
  "bank.ux.account.REJECTED": "Needs correction",
  "bank.ux.searchRecipient": "Search by name",
  "bank.ux.user": "Employee",
  "bank.ux.party": "Organization",
  "bank.ux.businessScope": "Businesses covered: {count}",
  "bank.ux.accessActive": "Access granted",
  "bank.ux.accessEnded": "Access ended",
  "merchant.ap.payment.title": "Prepare a payment list",
  "merchant.ap.payment.hint": "Select supplier invoices, check the list and save it. Creating drafts in the bank is a separate step.",
  "merchant.ap.loading": "Loading…",
  "bank.ux.expires": "List valid until {date}",
  "bank.ux.activity": "Bank settings updated",
  "bank.ux.activityAccess": "Payment preparation access changed",
  "bank.ux.activityKey": "Connection key downloaded",
  "bank.ux.employee": "Employee",
  "bank.ux.system": "System",
  "bank.ux.prepareShort": "New list",
  "merchant.ap.payment.review": "Check list",
  "merchant.ap.verifiedCapabilities": "Bank capabilities",
  "bank.ux.unavailable": "The bank connection or account needs attention. Open bank settings to check it.",
  "payments.workspace.title": "Supplier payments",
  "payments.workspace.recipient": "Recipient",
  "payments.workspace.status": "Payment status",
  "payments.workspace.group": "Group by recipient",
  "payments.workspace.bankDraftHint": "Sent to bank means a draft is available for signing. Payment is complete only after confirmation.",
  "payments.workspace.invoices": "Invoices",
  "payments.workspace.details": "Invoices and payment purpose",
  "payments.workspace.review": "Open invoice review",
  "payments.workspace.open": "Open payment",
  "payments.workspace.closePreparation": "Close preparation",
  "payments.workspace.prepare": "Prepare payments",
  "payments.workspace.incoming": "Incoming invoices in Goods",
  "payments.workspace.sourceHint": "Payments come from checked invoices recorded in Goods. Review the amount and recipient before preparing a bank draft.",
  "payments.state.REVIEW": "Needs review",
  "payments.state.READY": "Ready to send",
  "payments.state.PREPARING": "Being prepared",
  "payments.state.BANK_DRAFT": "Sent to bank · awaiting signature",
  "payments.state.PROCESSING": "Bank is processing",
  "payments.state.PAID": "Paid",
  "payments.state.PARTIAL": "Partially paid",
  "payments.state.ATTENTION": "Needs clarification",
  "payments.state.CANCELLED": "Cancelled",
  "payments.source.awaitingAccounting": "Awaiting accounting in Goods",
  "payments.source.pending": "Awaiting payment entry",
  "payments.source.beforeEnablement": "Recorded before payment tracking was enabled",
  "payments.source.unavailable": "Payment status unavailable",
  "payments.source.open": "Open payment",
  "payments.default.label": "Default for payments",
  "payments.default.set": "Make default",
  "payments.default.saved": "Default account saved. Existing drafts keep their account.",
  "payments.workspace.preparationHint": "Select invoices for the same recipient to combine them into a payment. Check the account, total and payment purpose before sending drafts to the bank.",
  "payments.workspace.sourceFilter": "Payments for the selected invoice",
  "payments.workspace.clearSource": "Show all payments",
  "payments.state.CLOSED": "Debt closed",
  "payments.state.PARTIALLY_CLOSED": "Debt partially closed",
  "payments.state.CREDIT": "Supplier credit available for offset",
  "payables.title": "Payables",
  "payables.sections": "Payment workspace",
  "payables.section.DUE": "To pay",
  "payables.section.WORKING": "In progress",
  "payables.section.COMPLETE": "Completed",
  "payables.section.ALL": "All",
  "payables.search": "Search recipient",
  "payables.tools": "More actions",
  "payables.back": "Back to payments",
  "payables.visibleInvoices": "Invoices shown: {count}",
  "payables.selectInvoice": "Select {invoices}",
  "payables.selected": "Selected: {count}",
  "payables.negativeSelection": "Select invoices to offset this credit.",
  "payables.prepare": "Prepare payments",
  "payables.retry": "Retry",
  "payables.reviewInvoice": "Review invoice",
  "payables.checkResult": "Check result",
  "payables.history": "View history",
  "payables.resolve": "View details",
  "payables.continue": "Continue",
  "payables.lastCheck": "Last update",
  "payables.supportCode": "Support reference",
  "payables.partPaid": "Paid {paid} · remaining {remaining}",
  "payables.partOffset": "Settled {paid} · remaining {remaining}",
  "payables.operationUncertain": "Some results in this payment group need clarification. Check the group before sending again.",
  "payables.uncertain": "The result is not confirmed. Check it before sending again.",
  "payables.emptyFiltered": "No matching invoices or payments.",
  "payables.empty.DUE": "No invoices to pay.",
  "payables.empty.WORKING": "No payments in progress.",
  "payables.empty.COMPLETE": "No completed payments.",
  "payables.empty.ALL": "No invoices or payments yet.",
  "payables.state.REVIEW": "Needs review",
  "payables.state.READY": "Ready to pay",
  "payables.state.PREPARING": "Prepared",
  "payables.state.BANK_DRAFT": "Sign in bank",
  "payables.state.PROCESSING": "Processing",
  "payables.state.PAID": "Paid",
  "payables.state.PARTIAL": "Partially paid",
  "payables.state.ATTENTION": "Needs clarification",
  "payables.state.CANCELLED": "Cancelled",
  "payables.state.CLOSED": "Debt settled",
  "payables.state.PARTIALLY_CLOSED": "Partially settled",
  "payables.state.CREDIT": "Credit for offset",
  "payables.issue.NOT_CREATED": "Draft not created",
  "payables.issueBody.NOT_CREATED": "Open payment details, resolve the issue and retry preparation.",
  "payables.issue.PAYABLE_REVIEW": "Review needed",
  "payables.issue.EXPIRED": "Preparation expired",
  "payables.issue.BANK_REJECTED": "Bank rejected the payment",
  "payables.issue.RESULT_UNCONFIRMED": "Needs clarification",
  "payables.issue.TIME_BUDGET": "Preparation paused",
  "payables.issue.STATUS_UNAVAILABLE": "Needs clarification",
  "payables.issueBody.PAYABLE_REVIEW": "Check the invoice details.",
  "payables.issueBody.EXPIRED": "Open saved preparation and select current invoices again.",
  "payables.issueBody.BANK_REJECTED": "Review the bank result and payment details.",
  "payables.issueBody.TIME_BUDGET": "Created drafts are saved. Continue the remaining invoices.",
};
